
export default function useKitchen(shopItems, inventoryItems) {
  const rows = [];
  if (!shopItems || !shopItems.length) {
    return { rows }
  }
  if (!inventoryItems) {
    inventoryItems = [];
  }
  const ownedFood = inventoryItems.filter((i) => i.getEffects().includes('FOOD'));
  const shopFood = shopItems.filter((i) => i.getEffects().includes('FOOD'));
  
  const ownedBurgers = ownedFood.filter(i => i.getName().toLowerCase().includes('burger'));
  const ownedRamen = ownedFood.filter(i => i.getName().toLowerCase().includes('ramen'));
  const ownedDrink = ownedFood.filter(i => i.getName().toLowerCase().includes('drink'));

  
  const shopBurgers = shopFood.filter(i => i.getName().toLowerCase().includes('burger'));
  const shopRamen = shopFood.filter(i => i.getName().toLowerCase().includes('ramen'));
  const shopDrink = shopFood.filter(i => i.getName().toLowerCase().includes('drink'));

  const commonBurgers = ownedBurgers.filter(i => i.getRarity() === 'common');
  const uncommonBurgers = ownedBurgers.filter(i => i.getRarity() === 'uncommon');
  const rareBurgers = ownedBurgers.filter(i => i.getRarity() === 'rare');
  const superRareBurgers = ownedBurgers.filter(i => i.getRarity() === 'super_rare');
  const legendaryBurgers = ownedBurgers.filter(i => i.getRarity() === 'legendary');

  const burgerRow = [];
  burgerRow.push(commonBurgers.length > 0 ? { item: commonBurgers[0], count: commonBurgers.length, type: 'consume' } : { item: shopBurgers.find(i => i.getRarity() === 'common'), type: 'shop'});
  burgerRow.push(uncommonBurgers.length > 0 ? { item: uncommonBurgers[0], count: uncommonBurgers.length, type: 'consume' } : { item: shopBurgers.find(i => i.getRarity() === 'uncommon'), type: 'shop'});
  burgerRow.push(rareBurgers.length > 0 ? { item: rareBurgers[0], count: rareBurgers.length, type: 'consume' } : { item: shopBurgers.find(i => i.getRarity() === 'rare'), type: 'shop'});
  burgerRow.push(superRareBurgers.length > 0 ? { item: superRareBurgers[0], count: superRareBurgers.length, type: 'consume' } : { item: shopBurgers.find(i => i.getRarity() === 'super_rare'), type: 'shop'});
  burgerRow.push(legendaryBurgers.length > 0 ? { item: legendaryBurgers[0], count: legendaryBurgers.length, type: 'consume' } : { item: shopBurgers.find(i => i.getRarity() === 'legendary'), type: 'shop'});
  rows.push(burgerRow);
  
  const commonDrink = ownedDrink.filter(i => i.getRarity() === 'common');
  const uncommonDrink = ownedDrink.filter(i => i.getRarity() === 'uncommon');
  const rareDrink = ownedDrink.filter(i => i.getRarity() === 'rare');
  const superRareDrink = ownedDrink.filter(i => i.getRarity() === 'super_rare');
  const legendaryDrink = ownedDrink.filter(i => i.getRarity() === 'legendary');

  const drinkRow = [];
  drinkRow.push(commonDrink.length > 0 ? { item: commonDrink[0], count: commonDrink.length, type: 'consume' } : { item: shopDrink.find(i => i.getRarity() === 'common'), type: 'shop'});
  drinkRow.push(uncommonDrink.length > 0 ? { item: uncommonDrink[0], count: uncommonDrink.length, type: 'consume' } : { item: shopDrink.find(i => i.getRarity() === 'uncommon'), type: 'shop'});
  drinkRow.push(rareDrink.length > 0 ? { item: rareDrink[0], count: rareDrink.length, type: 'consume' } : { item: shopDrink.find(i => i.getRarity() === 'rare'), type: 'shop'});
  drinkRow.push(superRareDrink.length > 0 ? { item: superRareDrink[0], count: superRareDrink.length, type: 'consume' } : { item: shopDrink.find(i => i.getRarity() === 'super_rare'), type: 'shop'});
  drinkRow.push(legendaryDrink.length > 0 ? { item: legendaryDrink[0], count: legendaryDrink.length, type: 'consume' } : { item: shopDrink.find(i => i.getRarity() === 'legendary'), type: 'shop'});
  rows.push(drinkRow);

  const commonRamen = ownedRamen.filter(i => i.getRarity() === 'common');
  const uncommonRamen = ownedRamen.filter(i => i.getRarity() === 'uncommon');
  const rareRamen = ownedRamen.filter(i => i.getRarity() === 'rare');
  const superRareRamen = ownedRamen.filter(i => i.getRarity() === 'super_rare');
  const legendaryRamen = ownedRamen.filter(i => i.getRarity() === 'legendary');

  const ramenRow = [];
  ramenRow.push(commonRamen.length > 0 ? { item: commonRamen[0], count: commonRamen.length, type: 'consume' } : { item: shopRamen.find(i => i.getRarity() === 'common'), type: 'shop'});
  ramenRow.push(uncommonRamen.length > 0 ? { item: uncommonRamen[0], count: uncommonRamen.length, type: 'consume' } : { item: shopRamen.find(i => i.getRarity() === 'uncommon'), type: 'shop'});
  ramenRow.push(rareRamen.length > 0 ? { item: rareRamen[0], count: rareRamen.length, type: 'consume' } : { item: shopRamen.find(i => i.getRarity() === 'rare'), type: 'shop'});
  ramenRow.push(superRareRamen.length > 0 ? { item: superRareRamen[0], count: superRareRamen.length, type: 'consume' } : { item: shopRamen.find(i => i.getRarity() === 'super_rare'), type: 'shop'});
  ramenRow.push(legendaryRamen.length > 0 ? { item: legendaryRamen[0], count: legendaryRamen.length, type: 'consume' } : { item: shopRamen.find(i => i.getRarity() === 'legendary'), type: 'shop'});
  rows.push(ramenRow);

  return { rows };
}

